export default __webpack_public_path__ + "static/media/HostaAI_LogoWithTagline.79b513db.png";